module.exports = __webpack_public_path__ + "img/skype.77ccfb86.svg";